import { envToBoolean } from './utils';

export const USE_CONSOLE_FOR_LOGS = envToBoolean(process.env.NEXT_PUBLIC_USE_CONSOLE_FOR_LOGS);
